import { Component, inject, OnInit } from '@angular/core';
import { BrandService } from '../../core/brand.service';
import { isMobileDevice } from '../../core/device.utils';
import { AppDownloadComponent } from '../app-download/app-download.component';

@Component({
  selector: 'app-site-footer',
  imports: [AppDownloadComponent],
  templateUrl: './site-footer.component.html',
  styleUrl: './site-footer.component.scss',
})
export class SiteFooterComponent implements OnInit {
  private readonly brand = inject(BrandService);

  readonly config = this.brand.brand.footer;
  readonly currentYear = new Date().getFullYear();
  isMobile = false;

  ngOnInit(): void {
    this.isMobile = isMobileDevice();
  }

  isSectionOpen(defaultOpen: boolean): boolean {
    return !this.isMobile || defaultOpen;
  }
}
